module.exports = __webpack_public_path__ + "images/places/asm_69-aa600bf0558240ee517927456e4a04c3.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/places/asm_69.jpg
 ** module id = 311
 ** module chunks = 0
 **/